var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter" },
    [
      _c(
        "div",
        { staticClass: "filter-header" },
        [
          _c("div", [_vm._v("查询搜索")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "auto" },
              attrs: {
                type: "text",
                icon: _vm.filterFold ? "el-icon-arrow-down" : "el-icon-arrow-up"
              },
              on: { click: _vm.toggleFilter }
            },
            [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.filterFold,
                expression: "!filterFold"
              }
            ]
          },
          [
            _c(
              "div",
              { staticClass: "filter-content" },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "demo-form-inline",
                    attrs: { inline: true, model: _vm.form }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "赔付单ID" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "赔付单ID", clearable: "" },
                          on: { clear: _vm.handleIdClear },
                          model: {
                            value: _vm.form.scId,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "scId", $$v)
                            },
                            expression: "form.scId"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "赔付原因" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "200px" },
                            attrs: { multiple: "", placeholder: "赔付原因" },
                            model: {
                              value: _vm.form.type,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "type", $$v)
                              },
                              expression: "form.type"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "货期超时", value: "1" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "缺货断货", value: "2" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "处理状态" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "200px" },
                            attrs: { multiple: "", placeholder: "状态" },
                            model: {
                              value: _vm.form.status,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "status", $$v)
                              },
                              expression: "form.status"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "待赔付", value: "1" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "已完成", value: "2" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "已作废", value: "3" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商家名称" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "商家名称", clearable: "" },
                          model: {
                            value: _vm.form.supplyName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "supplyName", $$v)
                            },
                            expression: "form.supplyName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商家ID" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "商家ID", clearable: "" },
                          model: {
                            value: _vm.form.supplyId,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "supplyId", $$v)
                            },
                            expression: "form.supplyId"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "赔付单生成时间" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "daterange",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "yyyy-MM-dd",
                            "picker-options": _vm.pickerOptions
                          },
                          on: {
                            change: function(val) {
                              return _vm.handleDateChange(val, "createdTime")
                            }
                          },
                          model: {
                            value: _vm.form.createdTime,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "createdTime", $$v)
                            },
                            expression: "form.createdTime"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "赔付单完成时间" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "daterange",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "yyyy-MM-dd",
                            "picker-options": _vm.pickerOptions
                          },
                          on: {
                            change: function(val) {
                              return _vm.handleDateChange(val, "completeTime")
                            }
                          },
                          model: {
                            value: _vm.form.completeTime,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "completeTime", $$v)
                            },
                            expression: "form.completeTime"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.handleSearch }
                          },
                          [_vm._v("查询")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success" },
                            on: { click: _vm.handleExport }
                          },
                          [_vm._v("导出列表")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success" },
                            on: { click: _vm.handleExportDetail }
                          },
                          [_vm._v("导出商品明细")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          { on: { click: _vm.handleCompensationSetting } },
                          [_vm._v("赔付设置")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e1c7fd1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e1c7fd1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/merchantClaimsOrder/components/SearchForm.vue
// module id = null
// module chunks = 